module.exports = __webpack_public_path__ + "static/media/digent.7bfef63a.svg";